/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from "react";
import { Helmet } from "react-helmet-async";

import Header1 from "parts/Header1";
import ProductsRubix16 from "partsproducts/ProductsRubix16";
import Footer from "parts/Footer";
import Products from "parts/ProductsBlog2.js";
import { RubixIO16, Blog2 } from "../json/ProductsPageData.js";

export default class RubixIOPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Helmet defer={false}>
          <title>Rubix iO-16 | Nube iO – Wireless I/O Expansion Module</title>
          <meta
            name="description"
            content="Add wireless I/O expansion to any BMS or HVAC system with the Rubix IO-16 — fast to install, easy to retrofit, and built to scale across site"
          />
          <meta
            name="keywords"
            content="wireless I/O module, LoRa® I/O, HVAC control, I/O expansion module"
          />
          <link rel="canonical" href="https://nube-io.com/io-modules/" />
          <meta
            property="og:title"
            content="Rubix iO-16 | Nube iO – Wireless I/O Expansion Module"
          />
          <meta
            property="og:description"
            content="Add wireless I/O expansion to any BMS or HVAC system with the Rubix IO-16 — fast to install, easy to retrofit, and built to scale across site"
          />
          <meta property="og:url" content="https://nube-io.com/io-modules/" />
        </Helmet>
        <Header1 />
        <ProductsRubix16 data={RubixIO16} />
        <Products data={Blog2} />
        <Footer />
      </>
    );
  }
}
